var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%","background-color":"rgba(0,0,0,0)"}},[_c('canvas',{ref:"container",staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }